module.exports = "<div class=\"container-fluid\">\n    <div class=\"card card-map\">\n        <div class=\"header\">\n            <h4 class=\"title\">Google Maps</h4>\n        </div>\n        <ngui-map zoom=\"13\" center=\"40.748817,-73.985428\" >\n         <marker [position]=\"[40.748817,-73.985428]\"></marker>\n           <map-circle\n               [center]=\"{lat: 40.748817, lng: -73.985428}\">\n           </map-circle>\n       </ngui-map>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/makebetter/Documents/sportsceneDash/src/app/maps/maps.component.html
// module id = ../../../../../src/app/maps/maps.component.html
// module chunks = 1